import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { SocialPostPreview, type SocialPostPreviewQuery, type SocialPostPreviewQueryVariables } from './api.graphql';

export async function socialPostPreview(
	url: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<SocialPostPreviewQuery['socialPostPreview']> {
	const { data } = await fetch<SocialPostPreviewQuery, SocialPostPreviewQueryVariables>({
		query: SocialPostPreview,
		variables: { input: { url } },
		// Must match the query's @restrictPath on the middle-end resolver.
		path: '/social-post-preview',
		rejectOnError: true,
		batched: false,
	});
	return data.socialPostPreview;
}
